import type { RutaProd } from '../../../../runtime/rutas';
export default {
  ruta: '/sistema/crm/Chats/Details/{id}',
  documento: 'crm',
  filas: ['148'],
  acceso: 'sesion',
  cita: 'prod:Areas/CRM/Controllers/ChatsController.cs',
} satisfies RutaProd;
